module["exports"] = [
  "gmail.com",
  "yahoo.ca",
  "hotmail.com"
];
